// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b9858bf3","455":"4e957421"}[chunkId] + ".chunk.js";
};